import React, { Component } from 'react'

class SendMessage extends Component {

    render() {
        return (<div>SendMessage</div>)
    }
}

export default SendMessage



/** WEBPACK FOOTER **
 ** ./src/components/PopupStats/ChatComponents/SendMessage.js
 **/